import { LogLevel } from 'services/logger.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { getClipTime, newClip, parseClipId } from 'components/app/_helpers/_app.helper';
import { appLogger } from 'components/app/_mediator/app-logger.slice';
import { handleClips } from 'components/app/editor/_mediator/editor.slice';
import { SbPosition } from 'components/app/editor/_mediator/editor-controls.slice';
import { clipsApi } from './editor-clips.helper';
import { sbApi } from './editor-clips-sb.helper';
import { findLinkByClipTime } from './editor-clips-linking.helper';
const ERR_ID = 'use-clips-error';

export const useClipsNotFound = () => {
  const clipsMap = useAppSelector((state) => state.editor.clipsMap);
  const storyBoard = useAppSelector((state) => state.editor.storyBoard);
  const linkedClips = useAppSelector((state) => state.editor.linkedClips);
  const selector = useAppSelector((state) => state.editor.selector);
  const dispatch = useAppDispatch();

  return (clipId: ClipId, sbPosition: SbPosition) => {
    console.error(`[${ERR_ID}]: clipData not found, attempting to recreate`, { clipId });
    dispatch(
      appLogger({
        level: LogLevel.Fatal,
        error: { name: `[${ERR_ID}]: clipData not found, attempting to recreate`, message: `clipId: ${clipId}` },
      })
    );
    if (!clipsMap || !selector) return;
    const clip = newClip(parseClipId(clipId));
    clip.clipGroupId = findLinkByClipTime(getClipTime(clip), linkedClips, clip.mediaFileId) ?? 0;
    const sb = sbApi(storyBoard).removeClip(clipId, sbPosition);
    dispatch(
      handleClips({
        data: { ...clipsApi(selector, { ...storyBoard, ...sb }, linkedClips).add([clip], sbPosition) },
        backupSkip: true,
      })
    );
  };
};
